import { render } from "./GoogleReviews.vue?vue&type=template&id=a40c1c7e&scoped=true"
import script from "./GoogleReviews.vue?vue&type=script&lang=js"
export * from "./GoogleReviews.vue?vue&type=script&lang=js"

import "./GoogleReviews.vue?vue&type=style&index=0&id=a40c1c7e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a40c1c7e"]])

export default __exports__